export const convertDataToApi = (data: any) => ({
  schoolId: data.schoolId,
  duration: data.duration.value,
  quantity: data.quantity,
  schoolPrefix: data.schoolPrefix || '',
  courses: data.courses,
});
